module.exports = __webpack_public_path__ + "img/8group-flyvr-icon.4a79d7a3.svg";